module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Nazwa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_name"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.nip)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_nip"
    }
  }, [_vm._v("NIP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.nip),
      expression: "item.nip"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_nip"
    },
    domProps: {
      "value": (_vm.item.nip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "nip", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.nip) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_nip_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.nip))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.regon)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_regon"
    }
  }, [_vm._v("REGON")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.regon),
      expression: "item.regon"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_regon"
    },
    domProps: {
      "value": (_vm.item.regon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "regon", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.regon) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_regon_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.regon))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.street)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_street"
    }
  }, [_vm._v("Ulica")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.street),
      expression: "item.address.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_street"
    },
    domProps: {
      "value": (_vm.item.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.street) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_street_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.street))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.number)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_number"
    }
  }, [_vm._v("Numer domu")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.number),
      expression: "item.address.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_number"
    },
    domProps: {
      "value": (_vm.item.address.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.number) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.number))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.postalCode)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_postalCode"
    }
  }, [_vm._v("Kod pocztowy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.postalCode),
      expression: "item.address.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_postalCode"
    },
    domProps: {
      "value": (_vm.item.address.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.postalCode) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_postalCode_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.postalCode))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.city)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_city"
    }
  }, [_vm._v("Miasto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.city),
      expression: "item.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_city"
    },
    domProps: {
      "value": (_vm.item.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.city) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_city_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.city))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.cessionAvailable)
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "_cessionAvailable"
    },
    model: {
      value: (_vm.item.cessionAvailable),
      callback: function($$v) {
        _vm.$set(_vm.item, "cessionAvailable", $$v)
      },
      expression: "item.cessionAvailable"
    }
  }, [_vm._v("Cesja możliwa")]), _vm._v(" "), (_vm.errors && _vm.errors.cessionAvailable) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_cessionAvailable_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.cessionAvailable))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.comments)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_comments"
    }
  }, [_vm._v("Uwagi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.comments),
      expression: "item.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_comments"
    },
    domProps: {
      "value": (_vm.item.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "comments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.comments) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_comments_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.comments))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'DebtorList'
      }
    }
  }, [_c('span', [_vm._v("Powrót")]), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f165682a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/debtor/Form.vue
// module id = 854
// module chunks = 0